import { Component, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { RouteProvider } from '../../providers/route/route';
import { SelectPickerPage } from '../../pages/select-picker/select-picker';
import { FormControlProvider } from '../../providers/formbuilder/formcontrol';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'rmt-picker',
  templateUrl: 'rmt-picker.html'
})
export class RmtPickerComponent {
  @Input() pickerParams: any = {};
  @Input() placeholder: string;
  @Input() disabled: boolean = false;
  @Input() showArrow: boolean = false;
  @Input() phoneCode: boolean = false;
  @Input() showListHeader?: boolean = false;
  @Input() numberPrefix: boolean = false;
  @Input() butnId: string = '';
  @Input() newDesign: boolean = false; 
  @Input() label;
  @Output() onShow = new EventEmitter<any>();  
  @Output() ionChange = new EventEmitter<string>();
  @ViewChild('select') select;
  @ViewChild('selectPicker', { read: ElementRef }) selectPicker;
  @Output() searchedText = new EventEmitter<string>();

   /**
   * The error message
  */
   @Input() errorMessage;
   @Input() defaultErrors: boolean = false;
   @Input() refFormControlError;
   @Input() hideError: boolean = false;
   @Input() showOnSubmit: boolean = false;
   @Input() refForm: FormGroup = null;
   @Input() submitAttempts: number = 0;
   @Input() isErrorHidden: boolean = true;
   @Input() isPhone: boolean = false;
   @Input() hideLabel: boolean = false;
   @Input() isEditable: boolean = true;
   @Input() addTopMargin: boolean = false;
   //#endregion error  
  selectedIcon;
  selectedFlag;
  selectedPrefix;
  selectItems;
  countries = null;
  text: string = '';
  loadingValue: boolean = false;
  hideSpinner: boolean = false;
  hideCaret: boolean = false;
  prefixCssClass = '';
  selectedItem;
  floatContainers;
  countrySelected;
  selectElemt;
  loadingPromise;
  loadingResolve;
  loadingResolveTimeout;
  isBase64Icon: boolean = false;
  private setValueSeq = 0;
  constructor(private routeProvider: RouteProvider,
    private formProvider: FormControlProvider) {}

    ngOnInit(){ // using var not function on html make the function call happen one time not repeating  
      this.prefixCssClass = this.getIonPrefixCssClass();
      this.loadingPromise = new Promise((resolve) => {
        this.loadingResolve = resolve;
      });
    }

    getSelectPickerClass(){
      let buttonClass = 'button btn-no-radius disable-hover rmt-picker rmt-picker-new';

      if(this.hideLabel == true){
        buttonClass += ' unset-select-text-top';
      }

      if(this.isEditable == false){
        buttonClass += ' select-not-editable';
      }

      return buttonClass;
    }

    getClassForFlag(){
      let flagClass = 'flag-container';

      if (this.selectedFlag == true) {
        flagClass +=  ' flag-container-has-flag';
      }
      if (this.disabled == true){
        flagClass += ' disable';
      }

      if(this.isEditable == false){
        flagClass += ' select-not-editable';
      }

      return flagClass

    }

    async setValue(value, triggerEvents: boolean = true) {
    const seq = ++this.setValueSeq;
    if (!this.hideSpinner) this.loadingValue = true;
    this.countries = await this.formProvider.getPhoneNumberCountriesRegistration();
    let items = this.pickerParams ? this.pickerParams.items : null;

    if (!items && this.pickerParams && this.pickerParams.itemsPromise) {
      if (!this.hideSpinner) this.loadingValue = true;
      items = await this.pickerParams.itemsPromise;
      this.loadingValue = false;
    }else{
      this.loadingValue = false;
    }
    if(this.loadingResolveTimeout){
      this.loadingResolveTimeout = null;
    }
    this.loadingResolveTimeout = setTimeout(() => {
      if (this.loadingResolve)
        this.loadingResolve(this.countries);
    }, 50);
    if (seq !== this.setValueSeq)
      return;
    items = SelectPickerPage.formatItems(this.pickerParams, items);
    for (let i=0; i < items.length; i++) {
      const item = items[i];
      if (item.value == value || item.selectedValue == value || item.Name == value) {
        this.selectItem(item, triggerEvents);
        return;
      }
    }
    this.deselect();   
  }

  ngAfterViewInit() {
    this.selectElemt = this.selectPicker.nativeElement;
  }

  async ngOnChanges(changes: any) {
    if(this.loadingPromise){
      await this.loadingPromise;
    };
    if(changes && changes.isEditable && changes.isEditable.currentValue !== changes.isEditable.previousValue && changes.isEditable.currentValue === false){
      this.hideCaret = true;
    }
  }
  
  getValue() {
    if (Array.isArray(this.select.value) && this.select.value.length === 0)
      return null;
    return this.select.value;
  }

  getText() {
    if (this.selectItems && this.selectItems.length > 0)
      return this.selectItems[0].text;
    return null;
  }

  deselect() {
    this.selectItems = null;
    this.select.value = null;
    this.selectedIcon = null;
    this.selectedPrefix = null;
    this.selectedItem = null;
    this.anyFunc(null);
  }

  selectItem(item, triggerEvents: boolean = true) {
    this.isBase64Icon = this.pickerParams.isBase64Icon || false;
    this.selectedItem =  item;
    let text = item.text || item.Name;
    if (item.selectedText)
      text = item.selectedText;
    if (this.isPhone && item.selectedText && item.selectedValue)
      text = `${item.selectedText} (+${item.selectedValue})`
    
    let value = item.text || item.Name;    
    if (item.value)
      value = item.value;
    if(this.numberPrefix){
      this.getCountryDetails(value);
    }
    
    this.selectItems = [{ text: text, value: value }];
    this.select.value = value;
    if (item.flag)
      this.selectedFlag = item.flag;
    else
      this.selectedIcon = item.icon;
    
    if(this.phoneCode)
      this.getCountryDetails(value, triggerEvents);
    else{
      this.text = value;
      if (triggerEvents)
        this.ionChange.emit(this.text);
    }
  }

  showPicker() {
    if (!this.disabled && this.isEditable && this.pickerParams){
      this.pickerParams.newDesign = this.newDesign;
      this.pickerParams.showListHeader = this.showListHeader;
      this.onShow.emit(this.pickerParams);
      if(this.selectedItem && this.pickerParams){
        this.pickerParams.itemSelected = this.selectedItem;
      }

      if(this.addTopMargin === true){
        this.pickerParams.addTopMargin = true;
      }
      

      this.routeProvider.openModal(this.routeProvider.pages.SelectPickerPage, this.pickerParams, (item) => {
        // If the returned item does not have an "itemSelected" property, it means the user selected an item directly.
        // In this case, we call selectItem() to handle the selection  as before .
        if (item && !item.hasOwnProperty("itemSelected")) {
          this.selectItem(item);
        }
        // If the item does have an "itemSelected" property, it indicates the user used the back button or did not select an item.
        // In this scenario, we emit the searched text instead.
        else {
          this.searchedText.emit(item)
        }
      });
    }
    return false;
  }

  async getCountryDetails(phone, triggerEvents: boolean = true){
    let country = null;
    let code = "";
    if (this.countries) {
      country = this.countries.find(country => country.category === phone);
      if (!country) {
        country = this.countries.find(country => country.value === phone);
        code = country.value;
      }
      else{
        code = country.selectedText;
      }
      if(this.numberPrefix)
        this.selectedPrefix = country.value;
      else{
        this.text = code;
        if (triggerEvents)
          this.ionChange.emit(this.text);
      }
    }
    return;
  }

  getIonPrefixCssClass() {
    if (this.showArrow && this.disabled) {
        return 'prefix-greyed-out';
    } else {
       return 'prefix';
    }
  }

  anyFunc(event) {
    if (this.selectElemt && this.selectElemt.parentNode) {
      if (event) {
        this.selectElemt.parentNode.classList.add('active');
      } else {
        this.selectElemt.parentNode.classList.remove('active');
      }
    }      
  }

  ngOnDestroy() {
    this.loadingPromise = null;
    this.loadingResolve = null;
    if (this.loadingResolveTimeout)
      window.clearTimeout(this.loadingResolveTimeout);
    this.loadingResolveTimeout = null;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-picker/rmt-picker.ts